<template>
  <div>
    <div class="content">
      <div style="display: flex;width: 100%;justify-content: space-between;">
        <div>
          <!-- <span>预计结束时间 </span> -->
          <el-date-picker size="small"
            v-model="value1"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getData(1)">
          </el-date-picker>
        </div>
        <Input search
          enter-button
          placeholder=" 请输入名称"
          v-model="fileNameOrTag"
          @on-search="getData(1)"
          style="width: 300px" />
      </div>
      <div style="margin-top: 20px;">
        <template>
          <el-table size="small"
            :data="tableData"
            style="width: 100%;margin-top: 15px">
            <el-table-column prop="number" label="考试编号"></el-table-column>
            <el-table-column prop="questionnaireVo.name" label="名称"></el-table-column>
            <el-table-column prop="questionnaireVo.passingScore" label="及格分数"></el-table-column>
            <el-table-column prop="passNum" label="及格人数"></el-table-column>
            <el-table-column prop="joinNum" label="参加人数"></el-table-column>
            <el-table-column prop="passRate" label="通过率"></el-table-column>
            <el-table-column prop="startTime" label="考试开始时间"></el-table-column>
            <el-table-column label="考试状态">
              <template slot-scope="{ row }">
                <span v-if="row.status === 0" style="color: #909399">未开始</span>
                <span v-if="row.status === 1" style="color: #67C23A">进行中</span>
                <span v-if="row.status === 2" style="color: #F56C6C">已结束</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <!-- <el-link type="primary" size="mini" @click.native.prevent="showData(scope.row)">详情</el-link> -->
                <el-link type="primary" size="mini" @click.native.prevent="detailBtn(scope.row)">详情</el-link>
                <span style="margin: 0 5px; color: #e8e8e8">|</span>
                <el-link type="danger" size="mini" @click.native.prevent="deleteData(scope.row.id)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px">
            <Page :total="total" :page-size="pageSize" @on-change="getData" :current="currentPage" />
          </div>
        </template>
      </div>
    </div>
    <Modal :styles="{width: '65%'}"
      v-model="isShow"
      title="发布试题"
      @on-ok="()=>{this.isShow = false}"
      @on-cancel="()=>{this.isShow = false}">
      <Table border
        :columns="columns1"
        :data="data1">
        <template slot-scope="{ row }"
          slot="answerStatus">
          <Tag size="medium" v-if="row.answerStatus == 0">未答题</Tag>
          <Tag size="medium" v-if="row.answerStatus == 1">已答题</Tag>
        </template>
        <template slot-scope="{ row }" slot="pass">
          <Tag size="medium" v-if="row.pass == 0">未通过</Tag>
          <Tag size="medium" v-if="row.pass == 1">已通过</Tag>
        </template>
      </Table>
    </Modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      columns1: [
        { title: '姓名', key: 'employeeName' },
        { title: '分数', key: 'score' },
        { title: '开始答题时间', key: 'startAnswerTime' },
        { title: '结束答题时间', key: 'endAnswerTime' },
        { title: '状态', slot: 'answerStatus' },
        { title: '是否通过', slot: 'pass' }
      ],
      data1: [],
      tableData: [],
      fileNameOrTag: '',
      pageSize: 10,
      currentPage: 1,
      form: {},
      total: 0,
      pageTotal: 0,
      value1: []
    }
  },
  methods: {
    showData(row) {
      this.data1 = row.examRecordEmployeeVos
      this.isShow = true
    },
    add: function() {
      this.$router.push({
        path: '/processManager/addQuestion'
      })
    },
    deleteData: function(id) {
      this.componentsMoudel.httpRequest
        .getRequestHander('/examrecord/delete/' + id)
        .openLoad()
        .startDel()
        .then(res => {
          if (this.tableData.length <= 1 && this.currentPage > 1) {
            this.currentPage -= 1
          }
          this.getData(this.currentPage)
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
        })
    },
    getData(page) {
      this.currentPage = page
      let param = {}
      param.limit = this.pageSize
      param.curPage = page
      param.name = this.fileNameOrTag
      if (this.value1 && this.value1.length > 0) {
        param.startTime = this.value1[0]
        param.endTime = this.value1[1]
      }
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData('urls').getExamrecord)
        .openLoad()
        .startPost(param)
        .then(res => {
          this.tableData = res.body.data
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].passRate =
              (this.tableData[i].passNum / this.tableData[i].joinNum) * 100
          }
          this.total = res.body.cum
          this.pageTotal = res.body.pageTotal
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    // 详情页面
    detailBtn(row) {
      this.$router.push({
        path: `examRecDetail`,
        query: { id: row.id, name: row.questionnaireVo.name, num: row.number }
      })
    }
  },
  mounted: function() {
    this.getData(1)
  },
  created() {}
}
</script>

<style scoped>
</style>
